const processSectionHeadingList = (node: any) => {
    const data = node.data || (node.data = {})
    data.hProperties = node.attributes
    const attrs = data.hProperties
    const maxLevel = attrs["max-level"]
    const newNode = node

    const elements = newNode.children
    let headings:any = []

    elements.map((element:any) => {
        if(element.type == 'heading' && element.depth <= maxLevel) {
            const listItemValue = element.children[0].hasOwnProperty('children') 
                ? element.children[0].children[0].value 
                : element.children[0].value

            const headingListItem =   {
                type: 'listitem',
                children:[{
                    type: 'link',
                    url: '#'+listItemValue.replace(/\s+/g, '-').toLowerCase(),
                    children: [{
                        type: 'text', 
                        value: listItemValue
                    }]
                }],
                data: { 
                    hName: 'li',
                }, 
            }
            headings.push(headingListItem)
        }
    })

    newNode.children.unshift({
        type: 'list',
        children: headings,
        data: { 
            hName: 'ul'
        }, 
    })

    data.hName = 'nav'
    data.hProperties.class = 'section-heading-list'
    data.hProperties.ariaLabel = 'Section heading list'
}

export default processSectionHeadingList
                